import { AllowedFileMIMEType, AllowedFileTypesEnum } from '../../legacy/shared-types';
import { IDetailesPageData } from 'queries/applications/useApplicationByReferenceNumber/types';

export const getMIMEByExtension = (fileName: string) => {
  const extension = fileName.split('.').pop()?.toLowerCase() as AllowedFileTypesEnum;

  return AllowedFileMIMEType[extension] || '';
};

export const headerSections: (keyof IDetailesPageData)[] = [
  'applicant1',
  'applicant2',
  'salesforceId',
  'status',
  'propertyAddress',
  'financeAmount',
  'ftv',
];
